import CommonModal from "./CommonModal";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message,
  children,
  confirmText = "Confirm",
  cancelText = "Cancel",
  type = "info", // 'info', 'warning', 'danger', 'success'
  size = "xs",
  showCancel = true,
}) => {
  const iconConfig = {
    info: {
      icon: (
        <svg
          className="w-6 h-6 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      confirmClass: "bg-blue-600 text-white hover:bg-blue-700",
    },
    warning: {
      icon: (
        <svg
          className="w-6 h-6 text-yellow-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      ),
      confirmClass: "bg-yellow-600 text-white hover:bg-yellow-700",
    },
    danger: {
      icon: (
        <svg
          className="w-6 h-6 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
      ),
      confirmClass: "bg-red-600 text-white hover:bg-red-700",
    },
    success: {
      icon: (
        <svg
          className="w-6 h-6 text-green-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      ),
      confirmClass: "bg-green-600 text-white hover:bg-green-700",
    },
  };

  const { icon, confirmClass } = iconConfig[type];

  const actions = [
    ...(showCancel
      ? [
          {
            label: cancelText,
            onClick: onClose,
            className: "border border-gray-300 text-gray-700 hover:bg-gray-50",
          },
        ]
      : []),
    {
      label: confirmText,
      onClick: onConfirm,
      className: confirmClass,
    },
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      actions={actions}
      size={size}
    >
      <div className="flex flex-col items-center text-center">
        <div
          className="w-12 h-12 bg-opacity-20 rounded-full flex items-center justify-center mb-4"
          style={{
            backgroundColor:
              iconConfig[type].icon.props.className
                .split(" ")[1]
                .replace("text-", "bg-") + "20",
          }}
        >
          {icon}
        </div>
        <div className="text-gray-600 w-full">{message}</div>
        {children != null && children !== false ? (
          <div className="mt-4 w-full text-left">{children}</div>
        ) : null}
      </div>
    </CommonModal>
  );
};

export default ConfirmationModal;
